import React from "react";
import PropTypes from "prop-types";
import * as R from "ramda";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MultiGrid, AutoSizer, SortDirection } from "react-virtualized";

import blue from "@material-ui/core/colors/blue";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import { withStyles } from "@material-ui/core";

import * as a from "./action";
import * as t from "./thunk";
import * as s from "./selector";
import { Panel as DateFilterPanel } from "./DateFilter";

// import {
//   enableNotifications,
//   disableNotifications,
//   sendMessage,
// } from "../Notifications";

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

function lower(s) {
  if (typeof s.toLowerCase === "function") return s.toLowerCase();
  return s;
}

class LogBatcher {
  constructor() {
    this.data = [];
    this.handle = setInterval(() => {
      let data = this.data;
      this.data = [];
      for (let d of data) {
      }
    }, 1000);
  }

  log(...args) {
    this.data.push(args);
  }
}

let lb = new LogBatcher();

// NOTE: I'm not sure how I feel about this being here.
// const cache = new CellMeasurerCache({
//   defaultWidth: 50,
//   minWidth: 30,
//   fixedHeight: true
// });

class DebouncedInput extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    delay: PropTypes.number,
  };

  static defaultProps = {
    onChange: (f) => f,
    delay: 200,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value || "",
    };

    this.debounce = null;
  }

  componentDidUpdate(props) {
    if (this.props.value != props.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    return (
      <TextField
        {...this.props}
        value={this.state.value}
        onChange={this.updateTextField}
      />
    );
  }

  tripOnChange() {
    if (this.debounce != null) {
      clearTimeout(this.debounce);
      this.debounce = null;
    }

    this.debounce = setTimeout(() => {
      this.props.onChange(this.state.value);
    }, this.props.delay);
  }

  updateTextField = (event) => {
    this.tripOnChange();
    this.setState({ value: event.target.value });
  };
}

const TableStyle = (theme) => ({
  table: {
    fontFamily: theme.typography.fontFamily,
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
  },
  tableRow: {
    cursor: "text",
  },
  tableRowHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "1.2rem",
    textAlign: "center",
    cursor: "text",
    backgroundColor: theme.palette.grey[800],
    color: "white",
  },
  tableRowHover: {
    "&:hover": {
      boxShadow: "inset 0 0 5px white",
      backgroundColor: theme.palette.grey[600],
    },
  },
  sortBy: {
    color: "black",
    backgroundColor: theme.palette.grey[200],
  },
  tableCellContent: {
    flex: 1,
    margin: 0,
    padding: 0,
    "&:hover": {
      // color: "white"
    },
  },
  tableCell: {
    textAlign: "center",
    transition:
      "transform .2s, color .2s, box-shadow .02s, padding .2s, background 0.2s, width 0.2s",
    overflow: "hidden",
    textWrap: "none",
    boxShadow: "0 0 0 0 black",
    alignItems: "center",
    flexDirection: "row",
    display: "flex",
    flex: 1,
    border: "none",
    background: `linear-gradient(to bottom, #fff, #fafaff)`,
    textAlign: "center",
    "&:hover": {
      overflow: "auto",
      color: "black",
      boxShadow: "inset 0 0 3px black",
      borderRadius: "0.2rem",
      whiteSpace: "nowrap",
      zIndex: 2000,
    },
    "&:active": {
      transform: "translate(0, .5%) scale(0.99)",
      boxShadow: "inset 0 0 9px black",
      background: "#e6ffe033",
    },
  },
  alignRight: {
    textAlign: "right",
  },
  greenCell: {
    boxShadow: `inset 0 0 1px green`,
    background: `linear-gradient(to right, #e6ffe5, #e6ffe0)`,
  },
  selectedCell: {
    boxShadow: `inset 0 0 1px blue`,
    background: `linear-gradient(to right, #0000ff11, #0000ff34)`,
  },
  arrow: {
    transition: "transform .2s, color .2s, box-shadow .02s, padding .2s",
    padding: ".2rem .4rem",
    userSelect: "none",
    borderRadius: ".2rem",
    color: "white",
    "&:hover": {
      userSelect: "none",
      color: "white",
      background: theme.palette.grey[800],
      transform: "translate(0, -.5%) scale(1.1)",
      boxShadow: "0 0 40px -10px black",
      zIndex: 2000,
    },
    "&:active": {
      transform: "translate(0, 1%) scale(0.9)",
      boxShadow: "0 0 40px -10px black",
      background: theme.palette.grey[700],
    },
  },
  arrowDown: {
    boxShadow: "inset 0 0 3px white",
  },
  arrowUp: {
    boxShadow: "0 0 3px white",
  },
  link: {
    transition: "text-shadow 0.2s",
    cursor: "pointer",
    color: blue[500],
    textShadow: `0 0 0px ${blue[600]}00`,
    "&:hover": {
      textShadow: `0 0 40px ${blue[600]}ff`,
      color: blue[600],
    },
  },
  tableCellStripe: {
    background: `linear-gradient(to right, #fafaff, #fafaff)`,
  },
  noClick: {
    cursor: "initial",
  },
  numericCell: {
    // textAlign: "right"
  },
  headerCell: {
    margin: 0,
    height: "1.5rem",
  },
});

const transformComponent = R.compose(
  connect(
    (state, props) => ({
      dataComponents: state.dataComponents,
      filter: s.filter(state, props),
      tableRows: s.tableRows(state, props),
      filteredData: s.filteredData(state, props),
      sortBy: s.sortBy(state, props),
      sortByDirection: s.sortDirection(state, props),
      columnOrder: s.columnOrder(state, props),
      // cursorCheck: s.cursorCheck(state, props),
      // cursors: s.cursors(state, props),
      crumb: s.crumb(state, props),
    }),
    (dispatch) => bindActionCreators({ ...a, ...t }, dispatch)
  ),
  withStyles(TableStyle)
);

class DataTable extends React.Component {
  static propTypes = {
    defaultSortBy: PropTypes.string,
    defaultSortDirection: PropTypes.oneOf(["up", "down"]),
    headerHeight: PropTypes.number,
    rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
    dataName: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        dataKey: PropTypes.string.isRequired,
        width: PropTypes.number,
        numeric: PropTypes.bool,
      })
    ),
  };

  static defaultProps = {
    defaultSortBy: "",
    defaultSortDirection: "down",
    headerHeight: 40,
    rowHeight: 30,
  };

  componentDidMount() {
    this.props.register(this.props.dataName, {
      direction: this.props.defaultSortDirection === "up" ? 1 : -1,
      sortBy: this.props.defaultSortBy,
      filter: "",
    });

    // this.props.enableNotifications();
  }

  componentWillUnmount() {
    this.props.unregister(this.props.dataName);
    // this.props.disableNotifications();
  }

  countRender() {
    const { filteredData, data } = this.props;
    let color = "black";
    let ratioCopy = this.entryCount;
    let percentCopy = "";

    if (this.props.filteredData.length !== this.props.data.length) {
      // This should display some green color
      color = "green";
      ratioCopy = (
        <span>
          showing <span style={{ color }}>{this.entryCount}</span> of{" "}
          <span style={{ color }}>{this.props.data.length}</span>
        </span>
      );
    }

    const textContent =
      this.entryCount === 0 ? (
        `No ${this.props.dataName}`
      ) : this.entryCount === 1 ? (
        `One ${this.props.dataName.substring(
          0,
          this.props.dataName.length - 1
        )}`
      ) : (
        <React.Fragment>
          <span>{ratioCopy}</span> <small>{this.props.dataName}</small>
        </React.Fragment>
      );

    return <p style={{ margin: 0 }}>{textContent}</p>;
  }

  renderCrumb() {
    return this.props.crumb ? (
      <div>
        Last Clicked: <span style={{ color: "green" }}>{this.props.crumb}</span>
      </div>
    ) : null;
  }

  get entryCount() {
    return this.props.filteredData.length;
  }

  render() {
    const { dataName } = this.props;

    return (
      <Paper style={{ display: "flex", flex: 1, flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            padding: "1rem",
            paddingBottom: "0",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <DebouncedInput
            delay={400}
            value={this.props.filter}
            onChange={(text) => this.props.setFilter(dataName, text)}
            style={{ flex: 1 }}
            placeholder="Search"
          />
          <DateFilterPanel />
          <Tooltip title="Download CSV" placement="top" enterDelay={500}>
            <IconButton onClick={() => this.props.downloadCSV(this.props)}>
              <CloudDownloadIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div
          style={{
            display: "flex",
            marginLeft: "1rem",
            marginRight: "1rem",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 1, textAlign: "left" }}>{this.countRender()}</div>
          <div style={{ flex: 1, textAlign: "right" }}>
            {this.renderCrumb()}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            margin: "1rem",
            minHeight: "400px",
          }}
        >
          <AutoSizer>
            {({ width, height }) => this.gridRenderer({ width, height })}
          </AutoSizer>
        </div>
      </Paper>
    );
  }

  gridCellHeaderRenderer = ({ columnIndex, key, rowIndex, style }) => {
    const { label, dataKey } = this.props.columns[columnIndex];
    const { classes } = this.props;
    const cellData = this.props.tableRows[rowIndex][columnIndex];

    return (
      <div
        onClick={() => this.props.handleSort(this.props, { sortBy: dataKey })}
        key={key}
        className={classNames(classes.tableRowHeader, classes.tableRowHover)}
        style={{
          overflow: "hidden",
          textWrap: "none",
          ...style,
        }}
      >
        <p className={classNames(classes.tableCellContent)}>
          <span
            dangerouslySetInnerHTML={{
              __html: rowIndex === 0 ? label : cellData,
            }}
          />
          {"  "}
          {this.props.sortBy === dataKey && (
            <small
              className={classNames(classes.arrow, {
                [classes.arrowUp]: this.props.sortByDirection > 0,
                [classes.arrowDown]: this.props.sortByDirection < 0,
              })}
              dangerouslySetInnerHTML={{
                __html: this.props.sortByDirection > 0 ? "&uarr;" : "&darr;",
              }}
            />
          )}
        </p>
      </div>
    );
  };

  isGreenCell(cellData) {
    try {
      if (this.props.filter === "") return false;
      let filters = this.props.filter
        .split(/\s+/)
        .map((f) => f.split(":").pop());
      for (let filter of filters)
        if (
          new RegExp(escapeRegExp(filter)).test(lower(cellData)) ||
          new RegExp(escapeRegExp(filter)).test(String(cellData))
        )
          return true;
      return false;
    } catch (error) {
      return false;
    }
  }

  // TODO: Split this into two functions.
  gridCellRenderer = ({ columnIndex, key, rowIndex, style }) => {
    const { dataName } = this.props;
    const { numeric, link, dataKey, label, alignRight } =
      this.props.columns[columnIndex];
    const { classes } = this.props;
    const cellProps = this.props.columns[columnIndex].props || {};
    let onClick = cellProps.onClick || null;
    const props = {};
    const cellData = this.props.tableRows[rowIndex][columnIndex];
    const greenCell = this.isGreenCell(cellData);
    const rowData = this.props.filteredData[rowIndex - 1];

    if (typeof onClick === "function") {
      props.onClick = (event) => {
        onClick(event, { cellData, columnIndex, rowData });
      };
    } else {
      props.onClick = (event) => {
        if (event.altKey) {
          if (rowIndex === 0 || link) return;
          this.props.setFilter(this.props.dataName, `${dataKey}:${cellData}`);
        }
        this.props.setCrumb(dataName, cellData, columnIndex, rowIndex);
        // this.props.setCursor(dataName, [columnIndex, rowIndex]);
      };
    }

    props.onDoubleClick = (e) => {
      const node = e.target;
      const range = document.createRange();
      range.setStart(node, 0);
      range.setEnd(node, 1); // here 0 and 4 is my location and length for the selection
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy", true);
      // this.props.sendMessage("Copied " + node.textContent);
    };

    return (
      <div
        {...props}
        key={key}
        className={classNames(classes.tableCell, {
          [classes.numericCell]: numeric,
          [classes.greenCell]: greenCell,
          [classes.alignRight]: alignRight,
          [classes.link]: link,
        })}
        style={style}
      >
        <p
          className={classNames(classes.tableCellContent)}
          dangerouslySetInnerHTML={{ __html: cellData }}
        />
      </div>
    );
  };

  gridRenderer = ({ width, height }) => {
    return (
      <MultiGrid
        tableRows={
          this.props.tableRows /* NOTE: This is a hack. Ask me about it. */
        }
        fixedRowCount={1}
        height={height}
        width={width}
        cellRenderer={(arg) =>
          arg.rowIndex === 0
            ? this.gridCellHeaderRenderer(arg)
            : this.gridCellRenderer(arg)
        }
        overscanRowCount={50}
        columnCount={this.props.columnOrder.length}
        columnWidth={150}
        rowCount={this.props.tableRows.length}
        rowHeight={45}
      />
    );
  };
}

DataTable = transformComponent(DataTable);

export { DataTable };
